import React, { useState } from 'react';
import { Button, Card, CardBody, CardHeader, FormGroup, Form, Input, Row, Col, Spinner } from "reactstrap";
import { useForm } from 'react-hook-form';
import { useReactToPrint } from 'react-to-print';
import Select from 'react-select';
import moment from "moment";

//Services
import { api_POST } from "services/api_service.js";
import { getSessionCookie } from 'services/session';
import { showMessage } from 'services/message';

//Helpers
import { formateDate } from 'helpers/formats';
import { formateDateandTime, formateDateApi } from 'helpers/formats';
import { nomeclaturas } from '../../../helpers/nomeclaturas';

// style
import "assets/css/loading.css";

function RelatorioManutecaoDestinos({ handleReturn }) {
  const session = getSessionCookie();

  const { register, handleSubmit } = useForm({ mode: "onBlur" });

  const [showDetail, set_showDetail] = useState(false);

  const [logs, setLogs] = useState([]);

  const [showLoading, setshowLoading] = useState(false);

  const [categoria, setCategoria] = useState(null);

  const [filtro, set_filtro] = useState({
    inicio: "",
    fim: "",
    nome: "",
    categoria: null
  });

  const verificarIndex = (object, vetor) => {
    let indice = -1;
    vetor.map((v, index) => {
      if (v.id === object.idRegistro) {
        indice = index;
      }
    })

    return (indice === -1 ? -1 : indice);
  }

  const formataDados = (dados) => {
    return dados ? dados.toString().replaceAll("_", "").replaceAll("-", "").trim() : "";
  }

  const geraRelatorio = (data) => {
    const vetor = [];

    data.map((info, index) => {
      vetor.push({
        id: info.idRegistro,
        usuario: info.usuario,
        data: formateDateandTime(info.dataAlteracao),
        cnpj: info.cnpj,
        nomeFantasia: info.nomeFantasia,
        camposEditados: []
      });

      const json_antigo = JSON.parse(info.jsonAntigo);
      const json_novo = JSON.parse(info.jsonNovo);

      Object.keys(json_antigo).map(x => {
        if (formataDados(json_antigo[x]) !== formataDados(json_novo[x]) && !Array.isArray(json_antigo[x]) && !Array.isArray(json_novo[x])) {
          if (x === "Arquivo") {
            vetor[verificarIndex(info, vetor)].camposEditados.push({ campo: `${x} (${json_novo["NomeArquivo"]})`, texto: `${json_novo["NomeArquivo"]}` });
          } else {
            vetor[verificarIndex(info, vetor)].camposEditados.push({ campo: x, texto: { antigo: json_antigo[x], novo: json_novo[x] } });
          }
        } else if (Array.isArray(json_antigo[x]) && Array.isArray(json_novo[x])) {
          json_antigo[x].map(antigo => {
            json_novo[x].map(novo => {
              Object.keys(novo).map(comp => {
                if (formataDados(antigo[comp]) !== formataDados(novo[comp])) {
                  vetor[verificarIndex(info, vetor)].camposEditados.push({ campo: comp, texto: { antigo: antigo[comp], novo: novo[comp] } });
                }
              })
            })
          })
        }
      })
    })

    setLogs(vetor);
  }

  const onSubmit = (data) => {
    if (categoria == null) {
      showMessage("Aviso", "Por favor, selecione a categoria.", 'warning', null);
      return;
    }

    let json_submit = {
      inicio: formateDateApi(data.dataInicial),
      fim: formateDateApi(data.dataFinal),
      categoria: categoria?.value
    }

    setshowLoading(true);

    api_POST("relatorio/RelatorioManutencaoDestinos", json_submit).then(result => {
      if (result.status !== 200) {
        set_showDetail(false);
        setshowLoading(false);
        showMessage("Aviso", result.message, 'error', null);
      } else {
        if(result?.data?.length == 0){
          set_showDetail(false);
          setshowLoading(false);
          showMessage("Aviso", "Não existem registros para os filtros informados.", 'warning', null);
          return;
        }
        geraRelatorio(result.data);
        json_submit.nome = session.nome;
        set_filtro(json_submit);
        set_showDetail(true);
        setshowLoading(false);
      }
    })
  }

  const componentRef = React.useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    copyStyles: true
  });

  return (
    <div className="content">
      <Row>
        <Col md="6" className="noPrint">
          <Button color="Primary" onClick={handleReturn}><i className="fas fa-chevron-left"></i>  Voltar</Button>
        </Col>
        {logs.length > 0 && showDetail &&
          <Col md="6" className="text-right noPrint">
            <Button color="danger" onClick={handlePrint}><i className="fas fa-print"></i></Button>
          </Col>
        }
      </Row>
      {logs.length === 0 &&
        (
          <Row>
            <Col md="12">
              <Card>
                <CardHeader>
                  <Row>
                    <Col md="9">
                      <h4 className="mb-0 mt-0">Manutenção de Destino</h4>
                      <label className="rel-subtitle">Relatório Detalhado de Manutenção de Destino.</label>
                    </Col>
                  </Row>
                </CardHeader>
                <CardBody>
                  <Form onSubmit={handleSubmit(onSubmit)}>
                    <Row className="noPrint">
                      <Col lg="4" md="4" sm="6">
                        <FormGroup>
                          <label className="form-control-label">Data Inicial <label className="text-danger">(Data da Manutenção)</label>:</label>
                          <Input className="form-control"
                            autoComplete="off"
                            type="date"
                            name="dataInicial"
                            innerRef={register({ required: true })}
                          />
                        </FormGroup>
                      </Col>
                      <Col lg="4" md="4" sm="6">
                        <FormGroup>
                          <label className="form-control-label">Data Final <label className="text-danger">(Data da Manutenção)</label>:</label>
                          <Input className="form-control"
                            autoComplete="off"
                            type="date"
                            name="dataFinal"
                            innerRef={register({ required: true })}
                          />
                        </FormGroup>
                      </Col>
                      <Col lg="4" md="4" sm="6">
                        <FormGroup>
                          <b><label><span className="text-danger">*</span> Categoria</label> </b>
                          <Select
                            options={[{ value: "RCC", label: "RCC" }, { value: "RGG", label: "RGG" }]}
                            getOptionLabel={option => option.label}
                            getOptionValue={option => option.value}
                            name="categoria"
                            onChange={(e) => setCategoria(e)}
                            value={categoria}
                            placeholder="Selecione"
                          />
                        </FormGroup>
                      </Col>
                      <Col lg="5" md="5" sm="12">
                        <Button color="info" className="btn-mobile" type="submit" > Gerar Relatório</Button>
                      </Col>
                    </Row>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        )
      }
      {
        showLoading && (
          <>
            <div className="carregandoCmp">
              <div className="box">
                <img src={require("assets/img/loading.gif")}></img>
              </div>
            </div>
          </>
        )
      }
      {
        logs.length > 0 && showDetail &&
        <>
          <Row>
            <Col md="12">
              <Card>
                <CardBody>
                  <ComponentToPrint
                    filtro={filtro}
                    relatorio={logs}
                    ref={componentRef}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </>
      }
    </div>
  );
}

export const ComponentToPrint = React.forwardRef((props, ref) => {
  const relatorio = props.relatorio;
  const filtro = props.filtro;

  function isDate(value) {
    const dateRegex = /^\d{4}-\d{2}-\d{2}(T\d{2}:\d{2}:\d{2}(\.\d{1,3})?)?$/;
    return dateRegex.test(value);
  }  

  return (
    <div ref={ref}>
      <div className="row">
        <div className="col-9">
          <h4 className="mb-0 mt-0">Manutenção de Destino {filtro?.categoria}</h4>
          <label>Relatório detalhado de Manutenção de Destino {filtro?.categoria}.</label>
        </div>
        <div className="col-3 text-right">
          <label>Gerado em {formateDateandTime(new Date())}
          </label>
        </div>
      </div>
      {filtro != null &&
        <div className="row rel-filter">
          <div className="col-5">
            <span><b>Período</b></span><br /><span>{`${formateDate(filtro.inicio)} a ${formateDate(filtro.fim)}`}</span>
          </div>
          <div className="col-4">
            <span><b>Gerado Por</b></span><br /><span>{filtro.nome}</span>
          </div>
        </div>
      }
      <h5><strong>Cadastros Atualizados</strong></h5>
      {
        relatorio != null && relatorio.map((value, key) => (
          <div key={key}>
            {value.camposEditados && value.camposEditados.length > 0 && (
              <>
                <div className="rel-group" >
                  <div className="row rel-item">
                    <div className="col-12">
                      <span><b>Razão Social:</b></span><span>{value.nomeFantasia === null || value.nomeFantasia === undefined ? " Sem Razão Social" : " " + value.nomeFantasia}</span>
                    </div>
                    <div className="col-12">
                      <span><b>CNPJ:</b></span><span>{value.cnpj === null || value.cnpj === undefined ? " Sem CNPJ" : " " + value.cnpj}</span>
                    </div>
                    <div className="col-6">
                      <span><b>Usuário de Modificação:</b></span><span>{" " + value.usuario}</span>
                    </div>
                    <div className="col-6">
                      <span><b>Data de Alteração:</b></span><span>{" " + value.data}</span>
                    </div>
                    <br />
                    <br />
                    {
                      value.camposEditados && value.camposEditados.map((atualizado, key2) => (
                        <>
                          <div className="col-6" key={key2}>
                            <span>
                              {/* caso o campo venha com nome de forma inadequada, sera usado o AlteraCampos*/}
                              <b>{nomeclaturas[atualizado.campo] !== undefined ? nomeclaturas[atualizado.campo] : atualizado.campo}</b>:
                            </span>
                            <span> {isDate(atualizado.texto.antigo) ? moment(atualizado.texto.antigo).format("DD/MM/YYYY HH:MM") : atualizado.texto.antigo}</span>
                          </div>
                          <div className="col-6" key={key2}>
                            <span className='text-danger'>
                              {/* caso o campo venha com nome de forma inadequada, sera usado o nomeclaturas*/}
                              <b>{nomeclaturas[atualizado.campo] !== undefined ? nomeclaturas[atualizado.campo] : atualizado.campo}</b>:
                            </span>
                            <span> {isDate(atualizado.texto.novo) ? moment(atualizado.texto.novo).format("DD/MM/YYYY HH:MM") : atualizado.texto.novo}</span>
                          </div>
                        </>
                      ))
                    }
                  </div>
                </div>
              </>
            )}
          </div>
        ))
      }
    </div>
  );
})

export default RelatorioManutecaoDestinos;